import React from 'react';
import { portalCopy } from '../copy';
import { PortalButton } from './PortalUi';

type PartnerEmptyStateProps = {
  onAddBusiness: () => void;
};

const PartnerEmptyState: React.FC<PartnerEmptyStateProps> = ({ onAddBusiness }) => (
  <div className="flex flex-col items-center rounded-[24px] border border-dashed border-[rgba(74,33,71,0.2)] bg-white px-6 py-14 text-center">
    <div className="flex h-14 w-14 items-center justify-center rounded-full bg-chisme-primary/10 text-2xl">
      ☕
    </div>
    <h2 className="mt-5 font-instrument text-2xl italic tracking-[-0.01em] text-[#2a0f2a]">
      {portalCopy.dashboard.emptyTitle}
    </h2>
    <p className="mt-2 max-w-md font-jakarta text-[15px] leading-relaxed text-[#5a3158]">
      {portalCopy.dashboard.emptySubtitle}
    </p>
    <PortalButton className="mt-8" onClick={onAddBusiness}>
      {portalCopy.dashboard.addBusiness}
    </PortalButton>
  </div>
);

export default PartnerEmptyState;
